const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";

/** Stored path only — must match server upload location (single segment under blog-pdfs). */
export function sanitizeBlogPdfPath(value) {
    const s = String(value || "").trim();
    if (!s.startsWith("/uploads/blog-pdfs/")) return "";
    const rest = s.slice("/uploads/blog-pdfs/".length);
    if (!rest || rest.includes("..") || rest.includes("/") || rest.includes("\\")) return "";
    if (!/\.pdf$/i.test(rest)) return "";
    return s;
}

/**
 * Absolute URL to open a blog PDF in the browser (API serves /uploads/...).
 * @param {string | undefined | null} pdfUrl stored value, e.g. /uploads/blog-pdfs/abc.pdf
 * @returns {string | null}
 */
export function resolveBlogPdfUrl(pdfUrl) {
    if (!pdfUrl || typeof pdfUrl !== "string") return null;
    const trimmed = pdfUrl.trim();
    if (!trimmed) return null;
    if (/^https?:\/\//i.test(trimmed)) return trimmed;
    const base = String(API_BASE_URL).replace(/\/$/, "");
    const pathPart = trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
    if (!base) return pathPart;
    return `${base}${pathPart}`;
}

/**
 * Display name for a stored PDF path or absolute URL (last path segment, e.g. `file.pdf`).
 * @param {string | undefined | null} pdfUrl
 * @returns {string}
 */
export function blogPdfFileName(pdfUrl) {
    if (!pdfUrl || typeof pdfUrl !== "string") return "PDF";
    const trimmed = pdfUrl.trim();
    if (!trimmed) return "PDF";
    try {
        const u = trimmed.includes("://") ? new URL(trimmed) : null;
        const path = u ? u.pathname : trimmed;
        const seg = path.split("/").filter(Boolean).pop();
        if (seg && /\.pdf$/i.test(seg)) return seg;
        return seg || trimmed || "PDF";
    } catch {
        const seg = trimmed.split("/").filter(Boolean).pop();
        return seg && seg.length > 0 ? seg : "PDF";
    }
}
